import axios from "axios";

const API_URL = "distributor/system-admin/summary/v1/data-summary/companyId";

export const getCompanyList = async (companyName) => {
  try {
    const response = await axios.get(API_URL, {
      params: { companyName },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching company ID:", error);
    throw error;
  }
};
export default getCompanyList;
